
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(252|27|483|74)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
